
import {
  computed, useRoute
} from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import { useChosenVariantDetailsStore } from '~/stores/useChosenVariantDetailsStore';
import useTracking from '~/composable/tracking/useTracking';
import useUtilities from '~/composable/useUtilities';
import { STOCK_STATUS } from '~/constants/StockStatus';
import useSavedUrls from '~/composable/useSavedUrls';
import { PURCHASE_CATEGORY } from '~/constants/PurchaseCategory';

export default {
  props: {
    offeredToCustomerType: {
      type: Array,
      default: () => []
    },
    hasSpecialPrices: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const { formatPrice } = useUtilities()
    const chosenVariantDetailsStore = useChosenVariantDetailsStore()
    const {
      chosenStorage,
      chosenColor,
      chosenChannel,
      chosenInstallment,
      productDetails
    } = storeToRefs(chosenVariantDetailsStore)
    const { track } = useTracking()
    const { saveBackUrl } = useSavedUrls()
    const route = useRoute()
    const categorySlug = route.value.params.categoryslug.toLowerCase()
    const expectedDeliveryDate = computed(() => productDetails?.value?.expectedDeliveryDate)
    const skuInStock = computed(() => productDetails?.value?.stockCheck)
    const purchaseCategory = computed(() => productDetails?.value?.purchaseCategory)
    const hasSubscriptionOptions = computed(() => {
      return productDetails?.value?.chosenVariantPriceMatrix?.subscriptionBundleOptions.find(option => option.channelReferenceID !== null) !== undefined
    })
    const addToBasketBtn = computed(() => {
      let btnText = skuInStock.value ? 'Køb' : 'Udsolgt'
      let btnVariant = skuInStock.value ? 'secondary' : 'gray'
      if (purchaseCategory.value === PURCHASE_CATEGORY.PRE_ORDER) {
        btnText = 'Forudbestil'
        btnVariant = 'tertiary'
      } else if (purchaseCategory.value === PURCHASE_CATEGORY.BACK_ORDER) {
        btnText = 'Bestil'
        btnVariant = 'tertiary'
      }
      return { btnText, btnVariant }
    })

    const updateChosenStorage = (event) => {
      chosenColor.value = productDetails.value.activeColor
      chosenStorage.value = event
      track('changeStorage', { storage: event, productDetails, chosenInstallment, chosenChannel })
    }

    const updateChosenColor = (event) => {
      chosenStorage.value = productDetails.value.activeStorage
      chosenColor.value = event
      track('changeColor', { color: productDetails.value.activeColorName, productDetails, chosenInstallment, chosenChannel })
    }

    const trackAddToBasket = () => {
      track('addToBasket', { productDetails, chosenInstallment, chosenChannel, categorySlug, label: addToBasketBtn.value.btnText })
    }

    const isPreOrder = computed(() => {
      return purchaseCategory.value === PURCHASE_CATEGORY.PRE_ORDER
    })

    const isBackOrder = computed(() => {
      return purchaseCategory.value === PURCHASE_CATEGORY.BACK_ORDER
    })

    const isPreOrderOrBackOrder = computed(() => {
      return isPreOrder.value || isBackOrder.value
    })
    const channelChosen = (chosen) => {
      chosenChannel.value = chosen
    }
    return {
      categorySlug,
      saveBackUrl,
      hasSubscriptionOptions,
      channelChosen,
      isPreOrder,
      isBackOrder,
      isPreOrderOrBackOrder,
      STOCK_STATUS,
      expectedDeliveryDate,
      purchaseCategory,
      formatPrice,
      skuInStock,
      chosenChannel,
      chosenInstallment,
      productDetails,
      addToBasketBtn,
      trackAddToBasket,
      updateChosenStorage,
      updateChosenColor,
      PURCHASE_CATEGORY
    }
  }
}
